export default {
    getConfigInquiryRegister: state => state.configInquiryRegister
}
